module.exports = __webpack_public_path__ + "img/D3_HQ02.8738f55f.jpg";